var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.876953C5.71442 0.876953 4.45772 1.25817 3.3888 1.9724C2.31988 2.68663 1.48676 3.70179 0.994786 4.88951C0.502816 6.07723 0.374095 7.38416 0.624899 8.64504C0.875703 9.90592 1.49477 11.0641 2.40381 11.9731C3.31285 12.8822 4.47104 13.5013 5.73192 13.7521C6.99279 14.0029 8.29973 13.8741 9.48744 13.3822C10.6752 12.8902 11.6903 12.0571 12.4046 10.9882C13.1188 9.91924 13.5 8.66253 13.5 7.37695C13.4967 5.65406 12.8108 4.00268 11.5925 2.78441C10.3743 1.56614 8.72289 0.880257 7 0.876953ZM10.5 7.87695H7C6.86739 7.87695 6.74022 7.82428 6.64645 7.73051C6.55268 7.63674 6.5 7.50956 6.5 7.37695V3.87695C6.5 3.74434 6.55268 3.61717 6.64645 3.5234C6.74022 3.42963 6.86739 3.37695 7 3.37695C7.13261 3.37695 7.25979 3.42963 7.35356 3.5234C7.44732 3.61717 7.5 3.74434 7.5 3.87695V6.87695H10.5C10.6326 6.87695 10.7598 6.92963 10.8536 7.0234C10.9473 7.11717 11 7.24434 11 7.37695C11 7.50956 10.9473 7.63674 10.8536 7.73051C10.7598 7.82428 10.6326 7.87695 10.5 7.87695Z",
    fill: "#D7C0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockLg);
export default __webpack_public_path__ + "static/media/clockLg.0c5857b3eb4245672d59f7ec3b207a1c.svg";
export { ForwardRef as ReactComponent };